var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"block",class:[_vm.sectionClass],style:({ height: _vm.sectionHeight })},[_c('div',{ref:"parallax",class:[_vm.parallax ? _vm.parallaxClass : '', _vm.fixed ? _vm.fixedClass : '', _vm.containerClass],style:({ 'min-height':_vm.sectionHeight })},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }